import { rgba } from 'polished';
import { mapValues } from 'radash';
import '../tokens/border-radiuses.js';
import { colorAlphas } from '../tokens/color-alphas.js';
import { colors } from '../tokens/colors.js';
import '../tokens/font-sizes.js';
import '../tokens/gaps.js';
import '../tokens/heights.js';
import '../tokens/spacings.js';
import '../tokens/widths.js';

/**
 * Available stroke color tone aliases.
 */ const strokeColorToneAliases = [
    'none',
    'weak',
    'medium',
    'strong'
];
/**
 * Collection of alias tokens for stroke colors. Tailored to outline and separate elements, gray is
 * fine-tuned for neutral outlines. Every hue, including gray, offers a range of tones for diverse
 * contexts.
 */ const strokeColorAliases = {
    light: {
        ...mapValues(colors, (color)=>({
                none: 'transparent',
                weak: rgba(color[500], colorAlphas.strong),
                medium: rgba(color[500], colorAlphas.stronger),
                strong: color[500]
            })),
        gray: {
            none: 'transparent',
            weak: rgba('black', colorAlphas.medium),
            medium: rgba('black', colorAlphas.strong),
            strong: rgba('black', colorAlphas.stronger)
        }
    },
    dark: {
        ...mapValues(colors, (color)=>({
                none: 'transparent',
                weak: rgba(color[300], colorAlphas.medium),
                medium: rgba(color[300], colorAlphas.strong),
                strong: color[400]
            })),
        gray: {
            none: 'transparent',
            weak: rgba('white', colorAlphas.weak),
            medium: rgba('white', colorAlphas.medium),
            strong: rgba('white', colorAlphas.strong)
        }
    }
};

export { strokeColorAliases, strokeColorToneAliases };
//# sourceMappingURL=stroke-colors.js.map
